import { Screen as QScreen } from 'quasar'
import variables from './../../assets/scss/shared/ds.variables.module.scss'

export enum PScreenSize {
  MOBILE = 'mobile',
  LAPTOP = 'laptop',
  DESKTOP = 'desktop',
}

type PBreakpoint = {
  mobileWidthMax: number
  laptopWidthMin: number
  laptopWidthMax: number
  desktopWidthMin: number
}

type PScreen = {
  isMobile: boolean
  isLaptop: boolean
  isLaptopOrSmaller: boolean
  isLaptopAndLarge: boolean
  isDesktop: boolean
  size: PScreenSize
  breakpoints: PBreakpoint
}

function isScreenLargerThan(width: number): boolean {
  return QScreen.width >= width
}

function isScreenSmallerThan(width: number): boolean {
  return QScreen.width <= width
}

export const screen = (): PScreen => {
  const isMobile = isScreenSmallerThan(parseInt(variables.mobileWidthMax))
  const isLaptop =
    isScreenLargerThan(parseInt(variables.laptopWidthMin)) &&
    isScreenSmallerThan(parseInt(variables.laptopWidthMax))
  const isDesktop = isScreenLargerThan(parseInt(variables.desktopWidthMin))

  return {
    isMobile,
    isLaptop,
    isLaptopOrSmaller: isScreenSmallerThan(parseInt(variables.laptopWidthMax)),
    isLaptopAndLarge: isScreenLargerThan(parseInt(variables.laptopWidthMin)),
    isDesktop,
    size: isMobile ? PScreenSize.MOBILE : isLaptop ? PScreenSize.LAPTOP : PScreenSize.DESKTOP,
    breakpoints: {
      mobileWidthMax: parseInt(variables.mobileWidthMax),
      laptopWidthMin: parseInt(variables.laptopWidthMin),
      laptopWidthMax: parseInt(variables.laptopWidthMax),
      desktopWidthMin: parseInt(variables.desktopWidthMin),
    },
  }
}
